module.exports = __webpack_public_path__ + "static/img/irole.cfc08ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/ch/irole.png
// module id = Yrjz
// module chunks = 7